import script from "./ZeroGood.vue?vue&type=script&setup=true&lang=js"
export * from "./ZeroGood.vue?vue&type=script&setup=true&lang=js"

import "./ZeroGood.vue?vue&type=style&index=0&id=8e76416e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e76416e"]])

export default __exports__